import { REQUEST_STATUSES, ROLES } from "shared/config";

const expenseRequestStatusesTable = {
  InternalOrder: {
    select: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
        REQUEST_STATUSES.AWAITING_SAP_EXPORT,
        REQUEST_STATUSES.AWAITING_SAP_IMPORT,
        REQUEST_STATUSES.PROCESSED,
      ],
    },
  },
  BasicDetails: {
    edit: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
      ],
    },
  },
  CostLine: {
    add: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
    },
    edit: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
      ],
    },
    delete: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
    },
    makeDecision: {
      [ROLES.SUPERVISOR]: [
        REQUEST_STATUSES.AWAITING_SUPERVISOR_ACTION,
        REQUEST_STATUSES.AWAITING_SUPERVISOR_SETTLEMENT_ACTION,
      ],
      [ROLES.ADDITIONAL_ACCEPTOR]: [
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_ACTION,
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_SETTLEMENT,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
      ],
      [ROLES.COST_GROUP]: [
        REQUEST_STATUSES.AWAITING_COST_GROUP_APPROVER,
        REQUEST_STATUSES.AWAITING_COST_GROUP_SETTLEMENT,
      ],
    },
    viewExpenseDoctype: {
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_SAP_EXPORT,
        REQUEST_STATUSES.AWAITING_SAP_IMPORT,
        REQUEST_STATUSES.PROCESSED,
        REQUEST_STATUSES.CANCELED,
      ],
    },
    editExpenseDoctype: {
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
      ],
    },
    selectVatExclusively: {
      [ROLES.COST_GROUP]: [
        REQUEST_STATUSES.AWAITING_COST_GROUP_APPROVER,
        REQUEST_STATUSES.AWAITING_COST_GROUP_SETTLEMENT,
      ],
    },
  },
  RequestControls: {
    view: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
      [ROLES.SUPERVISOR]: [
        REQUEST_STATUSES.AWAITING_SUPERVISOR_ACTION,
        REQUEST_STATUSES.AWAITING_SUPERVISOR_SETTLEMENT_ACTION,
      ],
      [ROLES.ADDITIONAL_ACCEPTOR]: [
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_ACTION,
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_SETTLEMENT,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
      ],
      [ROLES.COST_GROUP]: [
        REQUEST_STATUSES.AWAITING_COST_GROUP_APPROVER,
        REQUEST_STATUSES.AWAITING_COST_GROUP_SETTLEMENT,
      ],
    },
  },
};

const travelRequestStatusesTable = {
  InternalOrder: {
    select: {
      [ROLES.USER]: [
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
        REQUEST_STATUSES.AWAITING_SAP_EXPORT,
        REQUEST_STATUSES.AWAITING_SAP_IMPORT,
        REQUEST_STATUSES.PROCESSED,
      ],
    },
  },
  TravelLine: {
    add: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
    },
    edit: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
    },
  },
  CostLine: {
    add: {
      [ROLES.USER]: [REQUEST_STATUSES.AWAITING_USER_SETTLEMENT],
    },
    edit: {
      [ROLES.USER]: [REQUEST_STATUSES.AWAITING_USER_SETTLEMENT],
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
      ],
    },
    delete: {
      [ROLES.USER]: [REQUEST_STATUSES.AWAITING_USER_SETTLEMENT],
    },
    makeDecision: {
      [ROLES.SUPERVISOR]: [
        REQUEST_STATUSES.AWAITING_SUPERVISOR_ACTION,
        REQUEST_STATUSES.AWAITING_SUPERVISOR_SETTLEMENT_ACTION,
      ],
      [ROLES.ADDITIONAL_ACCEPTOR]: [
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_ACTION,
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_SETTLEMENT,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
      ],
      [ROLES.COST_GROUP]: [
        REQUEST_STATUSES.AWAITING_COST_GROUP_APPROVER,
        REQUEST_STATUSES.AWAITING_COST_GROUP_SETTLEMENT,
      ],
    },
    viewExpenseDoctype: {
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_SAP_EXPORT,
        REQUEST_STATUSES.AWAITING_SAP_IMPORT,
        REQUEST_STATUSES.PROCESSED,
        REQUEST_STATUSES.CANCELED,
      ],
    },
    editExpenseDoctype: {
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
      ],
    },
    selectVatExclusively: {
      [ROLES.COST_GROUP]: [
        REQUEST_STATUSES.AWAITING_COST_GROUP_APPROVER,
        REQUEST_STATUSES.AWAITING_COST_GROUP_SETTLEMENT,
      ],
    },
  },
  A1: {
    edit: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
      ],
    },
  },
  TicketsBooking: {
    edit: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
      ],
    },
  },
  RequestControls: {
    view: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
      [ROLES.SUPERVISOR]: [
        REQUEST_STATUSES.AWAITING_SUPERVISOR_ACTION,
        REQUEST_STATUSES.AWAITING_SUPERVISOR_SETTLEMENT_ACTION,
      ],
      [ROLES.ADDITIONAL_ACCEPTOR]: [
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_ACTION,
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_SETTLEMENT,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
      ],
      [ROLES.COST_GROUP]: [
        REQUEST_STATUSES.AWAITING_COST_GROUP_APPROVER,
        REQUEST_STATUSES.AWAITING_COST_GROUP_SETTLEMENT,
      ],
    },
  },
  BasicDetails: {
    edit: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
      ],
    },
  },
  AdvancePayment: {
    edit: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
      ],
    },
  },
  EstimatedTravelCosts: {
    edit: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
      ],
    },
  },
  EstimatedEmission: {
    edit: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
      ],
    },
  },
};

const eurocardRequestStatusesTable = {
  BasicDetails: {
    edit: {
      User: [REQUEST_STATUSES.DRAFT, REQUEST_STATUSES.AWAITING_USER_ACTION],
      [ROLES.ACCOUNTS_PAYABLE]: [REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE],
    },
  },
  ReasonOfRejection: {
    view: {
      [ROLES.USER]: [
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
    },
  },
  SubCosts: {
    edit: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE],
    },
  },
  RequestControls: {
    view: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
      [ROLES.SUPERVISOR]: [
        REQUEST_STATUSES.AWAITING_SUPERVISOR_ACTION,
        REQUEST_STATUSES.AWAITING_SUPERVISOR_SETTLEMENT_ACTION,
      ],
      [ROLES.ADDITIONAL_ACCEPPTOR]: [
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_ACTION,
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_SETTLEMENT,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
      ],
    },
  },
};

const creditcardRequestStatusesTable = {
  BasicDetails: {
    edit: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
      [ROLES.LOCAL_ADMINISTRATOR]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_SUPERVISOR_ACTION,
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_ACTION,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE],
    },
  },
  ReasonOfRejection: {
    view: {
      [ROLES.USER]: [
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
    },
  },
  SubCosts: {
    edit: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
      [ROLES.LOCAL_ADMINISTRATOR]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_SUPERVISOR_ACTION,
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_ACTION,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE],
    },
  },
  RequestControls: {
    view: {
      [ROLES.USER]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_USER_SETTLEMENT,
      ],
      [ROLES.LOCAL_ADMINISTRATOR]: [
        REQUEST_STATUSES.DRAFT,
        REQUEST_STATUSES.AWAITING_USER_ACTION,
        REQUEST_STATUSES.AWAITING_SUPERVISOR_ACTION,
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_ACTION,
      ],
      [ROLES.SUPERVISOR]: [
        REQUEST_STATUSES.AWAITING_SUPERVISOR_ACTION,
        REQUEST_STATUSES.AWAITING_SUPERVISOR_SETTLEMENT_ACTION,
      ],
      [ROLES.ADDITIONAL_ACCEPTOR]: [
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_ACTION,
        REQUEST_STATUSES.AWAITING_ADDITIONAL_ACCEPTOR_SETTLEMENT,
      ],
      [ROLES.ACCOUNTS_PAYABLE]: [
        REQUEST_STATUSES.AWAITING_AP_ACCEPTANCE,
        REQUEST_STATUSES.AWAITING_AP_SETTLEMENT,
      ],
    },
  },
};

export {
  expenseRequestStatusesTable,
  travelRequestStatusesTable,
  eurocardRequestStatusesTable,
  creditcardRequestStatusesTable,
};
